import { configureStore } from "@reduxjs/toolkit";
//import treatmentsReducer from '../features/treatmentsSlice/treatmentsSlice';
//import userTreatmentsReducer from '../features/userTreatments/userTreatmentsSlice';
import usersReducer from '../features/users/usersSlice';
import petsReducer from '../features/pets/petsSlice';
import petFormReducer from '../features/petForm/petFormSlice';
import eventFormReducer from '../features/eventForm/eventFormSlice';
import photoUploadReducer from "../features/photoUpload/photoUploadSlice";
import uiReducer from '../features/confirmations/confirmationsSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';
import feedbackReducer from '../features/feedback/feedbackSlice';
import articlesReducer from '../features/articles/articlesSlice';
import updatesReducer from '../features/updates/updatesSlice';
import eventTypesReducer from '../features/eventTypes/eventTypesSlice';
import legalPagesReducer from '../features/legalPages/legalPagesSlice';
import faqReducer from '../features/faq/faqSlice';


export const store = configureStore({
    reducer: {        
        //treatments: treatmentsReducer,
        //userTreatments: userTreatmentsReducer,
        users: usersReducer,
        pets: petsReducer, //for working with server
        petForm: petFormReducer, //for forms
        eventForm: eventFormReducer,
        photoUpload: photoUploadReducer,
        ui: uiReducer,
        notifications: notificationsReducer,
        feedback: feedbackReducer,
        articles: articlesReducer,
        updates: updatesReducer,
        eventTypes: eventTypesReducer,
        legalPages: legalPagesReducer,
        faq: faqReducer,
    }
});

export default store;